import React from 'react';
import { SvgIconProps } from '@mui/material';

export const TableIconNew: React.FC<SvgIconProps> = (props) => (
    <svg
        width="24"
        height="8"
        viewBox="0 0 24 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0.875 8V0.77H2.065L5.605 5.935V0.77H6.82V8H5.725L2.09 2.695V8H0.875ZM8.57031 8V0.77H13.3503L13.3453 1.815H9.79531V3.84H12.9303V4.87H9.78531V6.94L13.4203 6.945V8H8.57031ZM16.3532 8L14.2432 0.77H15.4432L16.9082 5.99L18.3782 0.77H19.2882L20.7682 5.99L22.2382 0.77H23.4432L21.3182 8H20.2932L18.8332 2.875L17.3532 8H16.3532Z"
            fill="currentColor"
        />
    </svg>
);

export default TableIconNew;
